import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WechatWorkFilledSvg from "@ant-design/icons-svg/es/asn/WechatWorkFilled";
import AntdIcon from '../components/AntdIcon';
var WechatWorkFilled = function WechatWorkFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: WechatWorkFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(WechatWorkFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'WechatWorkFilled';
}
export default RefIcon;